import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentorFormWidgetService } from 'common/widget/mentor/mentor-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class MentorFormResolver extends FormResolverService<MentorModel> {
    constructor(
        protected fs: MentorFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
